import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/layout.vue'
import Check from '@/views/check/index.vue'
import Writing from '@/views/writing/index.vue'
import Login from '@/views/login/index.vue'
import Video from '@/views/video/index.vue'
import Word from '@/views/word/index.vue'
import ImageCheck from '@/views/checkimage/index.vue'
import VideoCheck from '@/views/checkvideo/index.vue'
import userCenter from '@/views/user/index.vue'
import Image from '@/views/image/index.vue'
import Media from '@/views/media/index.vue'
import SsoCallback from '@/views/SsoCallback.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',  // 可选：'hash' 或 'history'
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/sso',
      name: 'SsoCallback',
      component: SsoCallback,
      meta: { title: '单点登录', requiresAuth: false }  // 不需要登录验证
    },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', name: 'check', component: Check },
        { path: 'writing', name: 'writing', component: Writing },
        { path: 'video', name: 'video', component: Video },
        { path: 'word', name: 'word', component: Word },
        { path: 'imagecheck', name: 'images', component: ImageCheck},
        { path: 'videocheck', name: 'videocheck', component: VideoCheck},
        { path: 'usercenter', name: 'usercenter', component: userCenter},
        { path: 'image', name: 'image', component: Image},
        { path: 'media', name: 'media', component: Media}
      ]
    }
  ]
})

/**
 * ===== 全局登录守卫 =====
 */
router.beforeEach((to, from, next) => {
  const publicPaths = ['/login', '/sso']
  const normalizedPath = to.path.replace(/\/+$/, '') || '/'

  if (to.matched.some(record => record.meta && record.meta.requiresAuth === false)) {
    return next()
  }

  const token = localStorage.getItem('token')
  // 已登录访问 login
  if (normalizedPath === '/login' && token) {
    return next('/')
  }

  if (publicPaths.includes(normalizedPath)) {
    return next()
  }

  if (!token) {
    return next('/login')
  }

  next()
})

export default router
